import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form: {
      maxWidth: "100%",
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      margin: "auto",
    },

    buttonsSection: {
      display: "flex",
      width: "100%",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      alignItems: "center",
      justifyContent: "center",
    },
    headerSection: {
      display: "grid",
      gridTemplateColumns: "repeat(1,0.1fr 1fr 0.1fr)",
      width: "100%",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      alignItems: "center",
    },
    title: {
      justifySelf: "center",
      [theme.breakpoints.down("xs")]: {
        fontSize: "22px",
      },
    },
    arrowBack: {
      width: "24px",
      height: "24px",
      textDecoration: "none",
      color: "black",
    },

    messageError: {
      display: "flex",
      height: "65vh",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",

      "& h2": {
        fontSize: "50px",
      },
    },
  })
);
